import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/default/header";
import ConnectionList from './connectionList';
import SidebarMenu from "./menu/sidebarMenu";
import Breadcrumb from "../default/breadcrumb/breadcrumb";

const CardConnection = () => {
    return (
        <div className="content-wrapper sidebar-menu-enable">
            <Helmet><title>Connection - Cardiast</title></Helmet>
            <Header />
            <div className="sidebar-with-content ds-flex">
               <SidebarMenu />
                <div className="content-right">
                    <Breadcrumb />
                    <ConnectionList />
                </div>
            </div>
        </div>
    );
}

export default CardConnection;